import React from 'react';

const DokanSettingsFieldLabel = ({ children }) => (
    <p className="text-base font-bold mt-5 mb-2">{children}</p>
);

export default DokanSettingsFieldLabel;
